
<template>
  <digital-clock :blink="true" />
</template>

<script>
import DigitalClock from 'vue-digital-clock'
export default {
  name: 'Relogio',
  components: { DigitalClock },
  data () {
    return {
    }
  },
}

</script>

<style scoped>
.clock {
  text-align: center;
  color: #ffffff;
  padding-left: 20px;
  font-size: 42px;
  font-family: "Menlo", monospace;
}
</style>
